import { render, staticRenderFns } from "./seatMapSeat.vue?vue&type=template&id=52bf06b8&"
import script from "./seatMapSeat.vue?vue&type=script&lang=js&"
export * from "./seatMapSeat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports